<template>
  <div class="navbar-dashboard-usuario">
    <el-dropdown trigger="click">
      <div class="el-dropdown-link ">
        <ul>
          <li :title="usuario.nome">{{usuario.nome.substring(0, 30)}}</li>
          <li class="navbar-dashboard-usuario-titulo">
            {{operadora.nome}}
          </li>
        </ul>
        <div>
          <div v-if="usuario.avatar" class="navbar-dashboard-usuario-img" :style="`background-image:url(${usuario.avatar});`"></div>
          <img v-else class="navbar-dashboard-usuario-img" src="@/assets/img/avatar-empresa-default.png" alt="Supervisor" title="Supervisor">
        </div>
        <div class="navbar-dashboard-icon">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link to="/minha-conta">
            <el-link :underline="false"><div class="link-titulo">Minha Conta</div></el-link>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <el-link :underline="false" v-on:click="logout"><div class="link-titulo">Logout</div></el-link>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'ItemNavbarUsuario',
  methods: {
    ...mapActions('login', [
      'logout'
    ])
  },
  computed: {
    ...mapState('login', [
      'usuario',
      'operadora'
    ])
  }
}
</script>

<style lang="scss" scoped>

.navbar-dashboard-usuario {
  display: block;
  vertical-align: middle;
  line-height: 15px;
  cursor: pointer;
}
.navbar-dashboard-usuario-titulo {
  text-align: right;
  font-family: Arial, Regular;
  font-size: 11px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}

.navbar-dashboard-usuario:focus {
  outline: none;
}

.el-dropdown-menu {
  width: 216px;
  box-shadow: 0 2px 4px #00000029;
  border-radius: 0;

  .link-titulo {
    color: #0075EA;
    width: 203px;
  }
}

.el-dropdown-link {
  color: #000000;
  display: grid;
  grid-template: 1fr / auto 35px 15px;
  align-items: center;
  justify-content: end;
  justify-items: end;
  margin:0;
  & > ul {
    padding: 0;
    list-style: none;
    text-align: right;
    max-width: 216px;
    grid-column-start: 1;
    grid-column-end: 1;
    margin-right: 10px;
    & > li {
      overflow: hidden;
      white-space: nowrap;
      text-align: right;
    }

    & .navbar-dashboard-usuario-titulo {
      font-weight: normal;
      text-transform: uppercase;
      font-family: Arial, Regular;
      font-size: 11px;
      letter-spacing: 0;
      color: #000000;
      opacity: 1;
    }
  } & .navbar-dashboard-icon {
      grid-column-start: 3;
      grid-column-end: 3;
      color: #0075EA;
      width: 15px;
    }
  & .navbar-dashboard-usuario-img {
    height: 35px;
    border-radius: 5px;
    border:1px solid #CCCCCC;
    width: 35px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: inline-block;
    grid-column-start: 2;
    grid-column-end: 2;
    margin: 0;
  }
}

a:-webkit-any-link{
  text-decoration: none;
}
</style>
